var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49996 0.083374C3.92532 0.083374 3.37422 0.311647 2.96789 0.717976C2.56157 1.1243 2.33329 1.67541 2.33329 2.25004C2.33329 2.82468 2.56157 3.37578 2.96789 3.78211C3.37422 4.18843 3.92532 4.41671 4.49996 4.41671C5.07459 4.41671 5.62569 4.18843 6.03202 3.78211C6.43835 3.37578 6.66663 2.82468 6.66663 2.25004C6.66663 1.67541 6.43835 1.1243 6.03202 0.717976C5.62569 0.311647 5.07459 0.083374 4.49996 0.083374ZM7.20829 5.50004H1.79163C1.36065 5.50004 0.947324 5.67125 0.642577 5.97599C0.337831 6.28074 0.166626 6.69406 0.166626 7.12504C0.166626 8.33404 0.663876 9.30254 1.47963 9.95796C2.28238 10.6025 3.35921 10.9167 4.49996 10.9167C5.64071 10.9167 6.71754 10.6025 7.52029 9.95796C8.33496 9.30254 8.83329 8.33404 8.83329 7.12504C8.83329 6.69406 8.66209 6.28074 8.35734 5.97599C8.05259 5.67125 7.63927 5.50004 7.20829 5.50004Z",
    fill: "#FF0000",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInfo);
export default __webpack_public_path__ + "static/media/user-info.a0ece74d542bc71328430ae638e75c0f.svg";
export { ForwardRef as ReactComponent };